import { useMutation } from 'react-query';
import { PublicSharedApiService } from 'shared/services/public-shared-api.service';
import { endpoint } from 'shared/services/shared-api.service';
import { UploadCertificatesParams } from './types';

const publicSharedApiService = new PublicSharedApiService(endpoint);

export const useUploadCertificates = () => {
  const mutationFn = (params: UploadCertificatesParams) => {
    return publicSharedApiService.create({
      path: 'public/accreditations',
      body: getFormData(params),
    });
  };

  return useMutation({ mutationFn });
};

function getFormData(params: UploadCertificatesParams): FormData {
  const formData = new FormData();
  params.files.forEach((file) => formData.append('files', file));
  formData.append('certificate', params.certificate);
  formData.append('accreditationType', params.accreditationType);
  formData.append('email', params.email);
  return formData;
}
